import React, { Fragment, useState, useEffect, useRef } from 'react'
import Sidebar from '../../layout/Sidebar'
import { connect } from 'react-redux';
import { logout } from '../../../actions/auth';
import { Link } from 'react-router-dom';
// import Spinner from '../../layout/Spinner';
import { createService } from '../../../actions/service';
import { getCategories } from '../../../actions/category';
import { getServiceTypes } from '../../../actions/service_type';
import { getPriceTypes } from '../../../actions/price_type';
import { getDurations } from '../../../actions/duration';



import PropTypes from 'prop-types';
import Header from '../Header';

const CreateService = ({ createService, getCategories, category: { categories }, getServiceTypes, servicetype: { servicetypes }, getPriceTypes, price_type: { price_types }, getDurations, duration: { durations } }) => {

    useEffect(() => {
        getServiceTypes();
    }, [getServiceTypes])

    useEffect(() => {
        getCategories();

    }, [getCategories]);
    useEffect(() => {
        getPriceTypes();

    }, [getPriceTypes]);

    useEffect(() => {
        getDurations();

    }, [getDurations]);
    const stepOne = useRef(null);


    const [formData, setFormData] = useState({
        serviceName: '',
        categoryTypeID: '',
        servDesc: '',
        afterDescription: '',
        serviceTypeID: '',
        durationID: '',
        priceTypeID: '',
        price: ''

    });
    const { serviceName, categoryTypeID, servDesc, afterDescription, serviceTypeID, durationID, priceTypeID, price } = formData;
    const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });
    const onSubmit = e => {
        stepOne.current.scrollIntoView({ block: "nearest", behavior: 'smooth' });

        e.preventDefault();
        createService({ serviceName, categoryTypeID, servDesc, afterDescription, serviceTypeID, durationID, priceTypeID, price });
        setFormData({
            serviceName: '',
            categoryTypeID: '',
            servDesc: '',
            afterDescription: '',
            serviceTypeID: '',
            durationID: '',
            priceTypeID: '',
            price: ''
        });

    };


    return (
        <Fragment>
            <div className='wrapper'>
                <Sidebar />
                <div className='servicePage' >
                    <Header heading="Create Service" />
                    <div className='createForm' ref={stepOne}>
                        <form className="form mt-5" onSubmit={e => onSubmit(e)}>
                            <div className="card">
                                <h5 className="card-header">Basic Info</h5>
                                <div className="card-body p-md-5 p-3">
                                    <div className='mb-5'>
                                        <label htmlFor='serviceName' className="form-label">Service name</label>
                                        <input type="text" className='form-control form-control-lg' name="serviceName" id='serviceName' value={serviceName} onChange={e => onChange(e)
                                        } required />
                                    </div>
                                    <div className='mb-5'>
                                        <label htmlFor='categoryTypeID' className="form-label">Service Category</label>
                                        <select
                                            id="categoryTypeID"
                                            name="categoryTypeID"
                                            value={categoryTypeID}
                                            onChange={e => onChange(e)

                                            }
                                            className="form-select form-select-lg"
                                        >
                                            <option value="">Select Category</option>
                                            {categories.map((category) => (
                                                <option value={category.id} key={`${category.categoryName}-${category.id}`}>
                                                    {category.categoryName}
                                                </option>
                                            ))
                                            }
                                        </select>

                                    </div>
                                    <div className="mb-5">
                                        <label htmlFor="servDesc" className="form-label">Service description</label>
                                        <textarea className='form-control form-control-lg' name="servDesc" id='servDesc' value={servDesc} onChange={e => onChange(e)
                                        } required />
                                    </div>
                                    <div className="mb-5">
                                        <label htmlFor="afterDescription" className="form-label">Aftercare description</label>
                                        <textarea className='form-control form-control-lg' name="afterDescription" id='afterDescription' value={afterDescription} onChange={e => onChange(e)
                                        } />
                                    </div>
                                    <div className='mb-5'>
                                        <label htmlFor='serviceType' className="form-label">Service available for</label>
                                        <select
                                            id="serviceTypeID"
                                            name="serviceTypeID"
                                            value={serviceTypeID}
                                            onChange={e => onChange(e)

                                            }
                                            className="form-select form-select-lg"
                                        >
                                            <option value="">Select available for</option>
                                            {servicetypes.map((serviceType) => (
                                                <option value={serviceType.id} key={`${serviceType.serviceTypeName}-${serviceType.id}`}>
                                                    {serviceType.serviceTypeName}
                                                </option>
                                            ))
                                            }
                                        </select>

                                    </div>
                                </div>
                            </div>


                            <div className="card mt-4">
                                <div className="card-header">
                                    <h5>Pricing and Duration</h5>
                                    <p className='text-secondary mt-2'>Add the pricing options and duration of the service.</p>
                                </div>
                                <div className="card-body p-md-5 p-2">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className='mb-5'>
                                                <label htmlFor='durationID' className="form-label">Duration</label>
                                                <select
                                                    id="durationID"
                                                    name="durationID"
                                                    value={durationID}
                                                    onChange={e => onChange(e)

                                                    }
                                                    className="form-select form-select-lg"
                                                >
                                                    <option value="">Select Duration</option>
                                                    {durations.map((duration) => (
                                                        <option value={duration.id} key={`${duration.durationValue}-${duration.id}`}>
                                                            {duration.hrs}hr {duration.min}min
                                                        </option>
                                                    ))
                                                    }
                                                </select>

                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className='mb-5'>
                                                <label htmlFor='priceTypeID' className="form-label">Price Type</label>
                                                <select
                                                    id="priceTypeID"
                                                    name="priceTypeID"
                                                    value={priceTypeID}
                                                    onChange={e => onChange(e)

                                                    }
                                                    className="form-select form-select-lg"
                                                >
                                                    <option value="">Select Price Type</option>
                                                    {price_types.map((pricetype) => (
                                                        <option value={pricetype.id} key={pricetype.id}>
                                                            {pricetype.priceTypeName}
                                                        </option>
                                                    ))
                                                    }
                                                </select>

                                            </div>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label htmlFor='price' className="form-label">Price</label>
                                            <input type="text" className='form-control form-control-lg' name="price" id='price' value={price} onChange={e => onChange(e)
                                            } required />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='text-center pt-4 d-flex justify-content-end'>
                                <Link to='/catalogue/services' className="btn btn-custom-ouline  me-4">Cancel</Link>
                                <input type="submit" className="btn btn-custom" value="Save" />
                            </div>
                        </form>

                    </div>
                </div>
            </div>

        </Fragment>
    )
}
CreateService.propTypes = {
    logout: PropTypes.func.isRequired,
    isAuthenticated: PropTypes.bool,
    category: PropTypes.object.isRequired,
    servicetype: PropTypes.object.isRequired,
    createService: PropTypes.func.isRequired,
    getCategories: PropTypes.func.isRequired,
    getServiceTypes: PropTypes.func.isRequired,
    price_type: PropTypes.object.isRequired,
    getPriceTypes: PropTypes.func.isRequired,
    getDurations: PropTypes.func.isRequired,
    duration: PropTypes.object.isRequired,
}
const mapStateToProps = state => ({
    isAuthenticated: state.auth.isAuthenticated,
    category: state.category,
    servicetype: state.service_type,
    price_type: state.price_type,
    duration: state.duration
});
export default connect(mapStateToProps, { createService, getCategories, getServiceTypes, getPriceTypes, getDurations, logout })(CreateService);
